<div class="card">
    <div class="card-body">
        <h5>{{'Danh sách phát hành hóa đơn' | translate}}</h5>
        <div class="">
            <div class="row d-flex justify-content-between">

                <div class="form-group col-3">
                    <label for="validationCustom01">{{ 'Số tài khoản' | translate }}</label>
                    <input type="tel" class="form-control" [(ngModel)]="filter.terminal_bank_acc"
                        placeholder="Nhập số tài khoản" (change)="submitFilter()" />
                </div>
                <div class="form-group col-3">
                    <label for="validationCustom01">{{ 'Số điện thoại' | translate }}</label>
                    <input type="tel" class="form-control" [(ngModel)]="filter.phone" placeholder="Nhập số điện thoại"
                        (change)="submitFilter()" />
                </div>
                <div class="form-group col-3">
                    <mat-form-field appearance="fill" class="mt-3">
                        <input matInput [matDatepicker]="monthPicker" formControlName="selectedMonth" [value]="
                date.controls.selectedMonth.value
                  ? (date.controls.selectedMonth.value | date : 'MM/yyyy')
                  : ''
              " placeholder="Chọn tháng" readonly />

                        <mat-datepicker-toggle matSuffix [for]="monthPicker"></mat-datepicker-toggle>
                        <mat-datepicker #monthPicker startView="multi-year"
                            (monthSelected)="onMonthSelected($event, monthPicker)"
                            panelClass="month-picker"></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="form-group col-3 d-flex mt-2">
                    <div class="col-4">
                        <div style="min-width: 200px;">
                            <div class="form-group">
                                <button class="btn btn-primary" (click)="submitFilter()">
                                    {{'PAGE.REPORT.Search' | translate}}
                                </button>
                                <button class="btn btn-dark ml-2" *ngIf="searching" (click)="clearFilter()">
                                    {{'FORM.Clear' | translate}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table id="basic-datatable" class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                <thead>
                    <tr class="bg-table">
                        <th>#</th>
                        <th width="100" *ngIf="role !== 'operation'">
                            {{'Quản lý' | translate}}
                        </th>
                        <th class="first-column">{{'Tên cửa hàng' | translate}}</th>
                        <th>{{'Số tài khoản' | translate}}</th>
                        <th>{{'Chủ TK' | translate}}</th>
                        <th>{{'Mã TB' | translate}}</th>
                        <th *ngIf="!full_name.includes('DD_CSKH')">{{'SĐT Khách' | translate}}</th>

                        <th>{{'Loại TB' | translate}}</th>
                        <th>{{'Gói DV' | translate}}</th>
                        <th>{{'Trạng thái' | translate}}</th>
                        <th>{{'Số tiền' | translate}}</th>
                        <th>{{'Loai đơn' | translate}}</th>
                        <th class="table-column">{{'Ngày tạo' | translate}}</th>
                        <!-- <th>{{'Ngày cập nhật' | translate}}</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of listData;let i=index">
                        <td class=" table-column">{{pageSize*(pageIndex-1) +i+1}}</td>
                        <td class="py-2 table-column" *ngIf="role !== 'operation'">
                            <div class="d-flex align-items-center" style="gap: 0.5rem;">
                                <a class="font-size-14 text-success" ngbTooltip="{{'Trạng thái' | translate}}"
                                    placement="left" (click)="onCheckPayment(data)">
                                    Kiểm tra
                                </a>
                            </div>
                            <ng-template #noCustomer>
                                <a class="font-size-18 text-success"
                                    *ngIf="data.status_eng == 'processing' && data.delivery_method !== 'direct' || data.status_eng == 'confirmed' && data.delivery_method !== 'direct' && role  !== 'delivery'"
                                    ngbTooltip="{{'Liên kết' | translate}}" placement="left"
                                    (click)="onLink(data, contentLink)">
                                    <i class="ri-links-line"></i>
                                </a>
                                <a class="font-size-18 text-waning"
                                    *ngIf="data.status_eng == 'complete' && data.delivery_method !== 'direct'  && role  !== 'delivery'"
                                    ngbTooltip="{{'Tạo đơn' | translate}}" placement="left" (click)="handleOrder(data)">
                                    <i class="ri-luggage-cart-line"></i>
                                </a>
                            </ng-template>
                        </td>
                        <td class=" table-column">{{data.full_name}}</td>

                        <td class=" table-column">{{data.terminal_bank_acc}}</td>

                        <td class="table-column-name">{{data.terminal_bank_acc_name}}</td>

                        <td class=" table-column">
                            {{data.serial_number || data.transaction_id || 'Chưa có '}}
                        </td>

                        <td *ngIf="!full_name.includes('DD_CSKH')" class=" table-column">
                            {{data.phone}}
                        </td>

                        <td class=" table-column">{{data.device_type_name}}</td>

                        <td class=" table-column">
                            <span *ngIf="data.duration">Gói {{data.duration | translate}} tháng</span>
                        </td>
                        <td>
                            <span class="badge" [ngClass]="statusPaymentColorMap[data.status]">
                                {{ statusPaymentMap(data.status) }}
                            </span>
                        </td>

                        <td class="table-column">
                            {{
                            data?.amount
                            ? data.amount
                            : (+data.discounted_price || 0) + (+data.fix_ship_fee || 0)
                            | number:'1.0-0'
                            }}
                            <sup><ins>đ</ins></sup>
                        </td>

                        <td class=" table-column">
                            <span class="font-size-12" *ngIf="data.transaction_type == 'renew'; else new">{{'Gia hạn' |
                                translate}}</span>
                            <ng-template #new>
                                <span class="font-size-12">{{'Đơn mới' | translate}}</span>
                            </ng-template>
                        </td>

                        <td class=" table-column">
                            {{data.created_at | date:'dd/MM/yyyy HH:mm'}}
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row justify-content-md-between align-items-md-center mt-2">
            <div class="col-sm-12 col-md-5">
                <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                    {{'TABLE.Showing' | translate}} {{pageSize*pageIndex - pageSize + 1}}
                    {{'TABLE.to' | translate}} {{pageSize*pageIndex}} {{'TABLE.of' |
                    translate}} {{totalCount}} {{'TABLE.entries' | translate}}
                </div>
            </div>
            <!-- Pagination -->
            <div class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end">
                <div class="text-md-right float-md-right pagination-rounded">
                    <ngb-pagination [collectionSize]="totalCount" [(page)]="pageIndex" [pageSize]="pageSize"
                        [maxSize]="5" [ellipses]="true" (pageChange)="fetchData()">
                    </ngb-pagination>
                </div>
                <div class="dataTables_length ml-3" id="tickets-table_length">
                    <label class="d-inline-flex align-items-center mb-0">
                        {{'TABLE.Show' | translate}}
                        <select name="tickets-table_length" aria-controls="tickets-table" name="pageSize"
                            [(ngModel)]="pageSize" (ngModelChange)="pageIndex = 1;fetchData()"
                            class="custom-select custom-select-sm form-control form-control-sm mx-2">
                            <option [ngValue]="10">10</option>
                            <option [ngValue]="25">25</option>
                            <option [ngValue]="50">50</option>
                            <option [ngValue]="100">100</option>
                        </select>
                        {{'TABLE.entries' | translate}}
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showOrderStatusPopup" class="order-status-popup-backdrop">
    <div class="order-status-popup-modal">
        <h5 class="mb-3 text-center">Kiểm tra trạng thái thanh toán thành công</h5>
        <div class="mb-3">
            <table class="table table-borderless mb-0">
                <tbody>
                    <tr>
                        <td class="font-weight-bold pr-2">Mã đơn hàng:</td>
                        <td>{{ checkedOrderData?.order_code || checkedOrderData?.id || '---' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold pr-2">Số tài khoản:</td>
                        <td>{{ checkedOrderData?.terminal_bank_acc || '---' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold pr-2">Tên cửa hàng:</td>
                        <td>{{ checkedOrderData?.full_name || '---' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold pr-2">Số tiền:</td>
                        <td>{{ checkedOrderData?.amount | number:'1.0-0' }} <sup><ins>đ</ins></sup></td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold pr-2">Ngày tạo:</td>
                        <td>{{ checkedOrderData?.created_at | date:'dd/MM/yyyy HH:mm' }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold pr-2">Trạng thái thanh toán:</td>
                        <td>
                            <span *ngIf="checkedOrderStatus" class="badge"
                                [ngClass]="statusPaymentColorMap[checkedOrderStatus]">
                                {{ statusPaymentMap(checkedOrderStatus) }}
                            </span>
                            <span *ngIf="!checkedOrderStatus">---</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end mt-4" style="gap: 12px;">
            <button class="btn btn-secondary" (click)="closeOrderStatusPopup()">Đóng</button>
        </div>
    </div>
</div>
<style>
    .order-status-popup-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.2);
        z-index: 1050;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .order-status-popup-modal {
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 16px rgba(0, 0, 0, 0.15);
        padding: 32px 28px 24px 28px;
        min-width: 340px;
        max-width: 95vw;
    }

    .badge {
        color: #fff !important;
        background-color: #6c757d !important;
        padding: 4px 12px;
        border-radius: 6px;
        font-size: 15px;
        font-weight: 500;
        display: inline-block;
        vertical-align: middle;
    }

    .badge-success {
        background-color: #28a745 !important;
    }

    .badge-secondary {
        background-color: #6c757d !important;
    }
</style>
<ng-template #content role="document" let-modal="close">
    <div class="modal-header">
        <h5 class="modal-title">
            {{(formData.value.id ? "FORM.Edit" : "FORM.AddNew") | translate}}
        </h5>
        <!-- <div *ngIf="makeForm('password').hasError('required')" class="error-message">
              Mật khẩu không được bỏ trống.
          </div> -->
        <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-3">
        <div class="text-left">
            <form (ngSubmit)="saveData()" [formGroup]="formData">
                <div class="row">
                    <!-- <div class="form-group row col-md-6">
                          <label class="col-md-2 col-form-label required_label">{{'Imei' | translate}}</label>
                          <div class="col-md-10">
                              <input type="text" class="form-control" formControlName="imei"
                                  [ngClass]="{'is-invalid': submitted && form.imei.errors}" />
                            
                          </div>
                      </div> -->
                    <!-- <div class="form-group row col-md-12" *ngIf="!formData.value.id"> -->

                    <div class="form-group row col-md-12">
                        <label class="col-md-2 col-form-label required_label">{{'Serial' | translate}}</label>
                        <div class="col-md-10">
                            <input type="text" class="form-control" formControlName="serial_number"
                                [ngClass]="{'is-invalid': submitted && form.serial_number.errors}" />
                        </div>
                    </div>
                    <div class="form-group row col-md-12">
                        <label class="col-md col-form-label required_label">{{'Model' | translate}}</label>
                        <div class="col-md-10">
                            <select class="form-select" aria-label="Default select example" class="form-control"
                                formControlName="model" [ngClass]="{'is-invalid': submitted && form.model.errors}">
                                <option value="{{item}}" *ngFor="let item of listModel">{{item}}</option>
                            </select>
                            <!-- <input type="text" class="form-control" formControlName="model"
                                  [ngClass]="{'is-invalid': submitted && form.model.errors}" />
                             -->
                        </div>
                    </div>

                    <div class="form-group row col-md-12">
                        <label class="col-md-2 col-form-label required_label">{{'Phiên bản' | translate}}</label>
                        <div class="col-md-10">
                            <select class="form-select" aria-label="Default select example" class="form-control"
                                formControlName="version" [ngClass]="{'is-invalid': submitted && form.version.errors}">
                                <option value="{{item}}" *ngFor="let item of listVersion">{{item}}</option>
                            </select>
                        </div>
                    </div>
                    <!-- <div class="form-group row col-md-12">
                          <label class="col-md-2 col-form-label required_label">{{'Trạng thái' | translate}}</label>
                          <div class="col-md-10">
                              <select class="form-select" aria-label="Default select example" class="form-control" formControlName="status"  [ngClass]="{'is-invalid': submitted && form.status.errors}">
                                  <option value="0" >Ngoại tuyến</option>
                                  <option value="1" >Trực tuyến</option>
                              </select>
                          </div>
                </div>-->
                </div>

                <div class="text-center">
                    <button type="button" class="btn btn-secondary btn-lg mr-3" style="width: 150px;"
                        (click)="modal('close click')">
                        {{'Đóng' | translate}}
                    </button>
                    <button type="submit" class="btn btn-success btn-lg" style="width: 150px;">
                        {{'Lưu' | translate}}
                    </button>
                    <!-- <button type="button" class="btn btn-secondary btn-sm" style="width: 150px"
                      (click)="modal('close click')">{{'FORM.Close' | translate}}</button>
                  <button type="button" class="btn btn-primary btn-sm ml-3" style="width: 150px"
                      (click)="updateFormNote()">{{'FORM.Save' | translate}}</button> -->
                </div>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #contentLink role="document" let-modal="close">
    <div class="modal-header">
        <h5 class="modal-title">
            Liên kết thiết bị với đơn hàng
        </h5>
        <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-3">
        <div class="text-left">
            <form (ngSubmit)="deviceLink(formData.value)" [formGroup]="formData">
                <div class="row">
                    <div class="form-group row col-md-12">
                        <label class="col-md-2 col-form-label required_label">{{'Đơn hàng' | translate}}</label>
                        <div class="col-md-10">
                            <input type="text" class="form-control" formControlName="data"
                                [ngClass]="{'is-invalid': submitted && form.data.errors}" disabled />
                        </div>
                    </div>

                    <div class="form-group row col-md-12">
                        <label class="col-md-2 col-form-label required_label">{{'Số thiết bị cần gán' |
                            translate}}</label>
                        <div class="col-md-10">
                            <input disabled type="text" class="form-control" formControlName="quantity"
                                [ngClass]="{'is-invalid': submitted && form.quantity.errors}" />
                        </div>
                    </div>
                    <div class="form-group row col-md-12">
                        <label class="col-md-2 col-form-label required_label">{{'Thiết bị' | translate}}</label>
                        <div class="col-md-10">
                            <ng-select [items]="listDevices" bindLabel="serial_number" bindValue="serial_number"
                                formControlName="serial_number" [maxSelectedItems]="formData.get('quantity').value"
                                [multiple]="true" placeholder="{{ 'Chọn thiết bị' | translate }}"
                                [ngClass]="{'is-invalid': submitted && form.serial_number.errors}">
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div class="text-center">
                    <button type="button" class="btn btn-secondary btn-lg mr-3" style="width: 150px;"
                        (click)="modal('close click')">
                        {{'Đóng' | translate}}
                    </button>
                    <button type="submit" class="btn btn-success btn-lg" style="width: 150px;">
                        {{'Lưu' | translate}}
                    </button>
                </div>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #contentDetail role="document" let-modal="close">
    <div class="modal-header">
        <h5 class="modal-title">
            Chi tiết đơn hàng Online
        </h5>
        <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-3">
        <div class="text-left">
            <form (ngSubmit)="deviceLink(formData.value)" [formGroup]="formData">
                <div class="row">
                    <div class="form-group row col-md-12">
                        <label class="col-md-2 col-form-label required_label">{{'Người nhận' | translate}}</label>
                        <div class="col-md-10">
                            <input type="text" class="form-control" formControlName="customer_name"
                                [ngClass]="{'is-invalid': submitted && form.customer_name.errors}" disabled />
                        </div>
                    </div>

                    <div class="form-group row col-md-12">
                        <label class="col-md-2 col-form-label required_label">{{'Số điện thoại' | translate}}</label>
                        <div class="col-md-10">
                            <input disabled type="text" class="form-control" formControlName="phone"
                                [ngClass]="{'is-invalid': submitted && form.phone.errors}" />
                        </div>
                    </div>
                    <div class="form-group row col-md-12">
                        <label class="col-md-2 col-form-label required_label">{{'Địa chỉ' | translate}}</label>
                        <div class="col-md-10">
                            <input disabled type="text" class="form-control" formControlName="address"
                                [ngClass]="{'is-invalid': submitted && form.address.errors}" />
                        </div>
                    </div>
                </div>

                <div class="text-center">
                    <button type="button" class="btn btn-secondary btn-lg mr-3" style="width: 150px;"
                        (click)="modal('close click')">
                        {{'Đóng' | translate}}
                    </button>
                    <!-- <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px;"
          >
            {{'Lưu' | translate}}
          </button> -->
                </div>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #contentKeyword let-modalHis="close">
    <div class="modal-header">
        <h5 class="modal-title">List keyword of "{{selectedIncident.name}}"</h5>
        <button type="button" class="close" aria-label="Close" (click)="modalHis('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-3">
        <div class="mb-3" *ngIf="formNewKeyword">
            <h5 class="font-size-14">Add New Keyword</h5>
            <form [formGroup]="formNewKeyword" (submit)="onSubmitFormKeyword(2)" class="d-flex">
                <input type="text" class="form-control form-control-sm" style="width: 250px;" formControlName="name" />
                <button class="btn btn-primary btn-sm ml-3" style="width: 150px;">
                    Add
                </button>
            </form>
        </div>
        <div class="table-responsive">
            <table id="basic-datatable" class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                <thead>
                    <tr>
                        <th width="50">#</th>
                        <th>Name</th>
                        <!-- <th>Thời gian</th> -->
                        <th width="170"></th>
                    </tr>
                </thead>
                <tbody *ngFor="let data of dataKeyword;let i=index">
                    <tr>
                        <td class=" table-column">{{i+1}}</td>
                        <td class=" table-column">
                            <ng-container *ngIf="selectedKeyword?.id == data.id && formEditKeyword; else normal">
                                <form [formGroup]="formEditKeyword" (submit)="onSubmitFormKeyword(1)">
                                    <input type="text" class="form-control form-control-sm" formControlName="name" />
                                </form>
                            </ng-container>
                            <ng-template #normal>{{data.name}}</ng-template>
                        </td>
                        <!-- <td class=" table-column">{{data.created_at*1000 | date:'dd/MM/yyyy HH:mm'}}</td> -->
                        <td class=" table-column">
                            <div class="d-flex" style="gap: 10px;">
                                <a class="btn btn-sm btn-success" href="javascript: void(0);"
                                    (click)="editKeyword(data,i)">
                                    <i class="mdi mdi-account-edit"></i>{{'FORM.Edit' |
                                    translate}}</a>
                                <a class="text-white btn btn-sm btn-danger" (click)="onDeleteKeyword(data.id)"><i
                                        class="mdi mdi-delete"></i>{{'FORM.Delete' |
                                    translate}}</a>
                            </div>
                            <!-- <button class="btn" (click)="editKeyword(data,i)">Sửa</button>
                              <button>Xoá</button> -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-template>